export const normalizeActionLogStatus = status => String(status || '').trim().toLowerCase();

// Keep unknown configuration visible; a pending request always requires attention.
export const needsHumanValidation = overview => (
  overview?.humanValidationRequired !== false || overview?.pending > 0
);

export const getProjectFunnelLabels = (project, language) => {
  try {
    const raw = project?.funnelLabels;
    const labels = typeof raw === 'string' ? JSON.parse(raw) : raw;
    const localized = labels?.[String(language || 'en').split('-')[0]] || labels?.en;
    return localized && ['received', 'processing'].every(key => typeof localized[key] === 'string' && localized[key].trim())
      ? localized : {};
  } catch (_error) {
    return {};
  }
};

export const getWorkspaceCohortRange = (days = 7, now = new Date()) => {
  const periodDays = [1, 7, 30].includes(Number(days)) ? Number(days) : 7;
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  start.setDate(start.getDate() - periodDays + 1);
  const end = new Date(now);
  end.setHours(23, 59, 59, 999);
  // Browser-local calendar boundaries, expressed as UTC for stored timestamps.
  const format = date => date.toISOString().slice(0, -1);
  return { start_date: format(start), end_date: format(end) };
};

export const getTodayActionRange = (now = new Date()) => getWorkspaceCohortRange(1, now);

// Never show a partial total as if it covered all displayed processes.
export const sumOverviewMetric = (overviews, key) => (
  overviews.length && overviews.every(item => Number.isFinite(item?.[key]))
    ? overviews.reduce((total, item) => total + item[key], 0)
    : null
);
